/**
 * 其知网 分类管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>分类管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" style="width:140px" placeholder="输入分类名称"></el-input>
        <el-select size="small" v-model="formInline.type" style="width:140px" placeholder="请选择">
          <el-option v-for="type in categoryType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="name" align="center" label="分类名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type_name" align="center" label="分类类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="icon" align="center" label="分类图标" show-overflow-tooltip>
        <template slot-scope="scope">
        　  <img :src="scope.row.icon" width="30" height="30" class="head_pic" v-if="scope.row.icon"/>
        </template>
      </el-table-column>
      <el-table-column prop="admin_name" align="center" label="操作人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sort" align="center" label="排序值" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="upd_time" align="center" label="更新时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150px">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delCate(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-row>
            <el-form-item label="分类名称" prop="name">
              <el-input size="small" v-model="infoForm.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="分类图标">
              <el-upload
                class="avatar-uploader"
                action="https://zlbb.qzhip.com/index.php/index/base/uploadFile"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="infoForm.icon" :src="infoForm.icon" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select size="small" v-model="infoForm.type" style="width:140px" placeholder="请选择">
                <el-option v-for="type in cateType" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序值" prop="sort">
              <el-input size="small" v-model="infoForm.sort" auto-complete="off" placeholder="值越小越靠前"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitForm('infoForm')">保存</el-button>
              <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { webCategoryList, webEditCategory, webUrl, webDelCategory } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加分类',
      multipleSelection: [],
      cateType: [
        { key: '代理人行业', value: 1 },
        { key: '专利市场', value: 2 },
        { key: '其知学院', value: 3 },
        { key: '代理人专业', value: 4 },
        { key: '其说', value: 5 },
        { key: '热门领域', value: 6 },
      ],
      categoryType: [
        { key: '全部', value: 0 },
        { key: '代理人行业', value: 1 },
        { key: '专利市场', value: 2 },
        { key: '其知学院', value: 3 },
        { key: '代理人专业', value: 4 },
        { key: '其说', value: 5 },
        { key: '热门领域', value: 6 },
      ],
      infoForm: {
        id: '',
        name: '',
        type: '',
        icon: '',
        sort: '',
      },
       formInline: {
        page: 1,
        ps: 10,
        name: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      infoFormRules: {
        name: [{required: true, message: '请输入分类名称', trigger: 'blur'}],
        type: [{required: true, message: '请选择所属类型', trigger: 'blur'}],
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        console.log(parameter)
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webCategoryList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑分类'
        this.infoForm.id = row.id
        this.infoForm.name = row.name
        this.infoForm.icon = row.icon
        this.infoForm.type = row.type
        this.infoForm.sort = row.sort
      } else {
        this.title = '添加分类'
        this.infoForm.id = ''
        this.infoForm.name = ''
        this.infoForm.icon = ''
        this.infoForm.type = ''
        this.infoForm.sort = ''
      }
    },
    // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.infoForm.icon = res.data.url
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
    // 编辑、增加页面保存方法
    submitForm(infoForm) {
      this.$refs[infoForm].validate(valid => {
        if (valid) {
          webEditCategory(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('系统错误!')
            })
        } else {
          return false
        }
      })
    },
    // 删除监控记录
    delCate(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {id:row.id}
          webDelCategory(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('分类删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Category.vue